module.exports = __webpack_public_path__ + "img/pantalla-6-1-1.a0585173.png";